import React from "react";
import CustomImage from "./CustomImage";

interface Advertisement {
  url: string;
  link: string;
}

interface AdvertisementSectionProps {
  matchedAdvertisement: Advertisement | null;
  isMobile: boolean;
}

const AdvertisementSection: React.FC<AdvertisementSectionProps> = ({ 
  matchedAdvertisement, 
  isMobile 
}) => {
  if (!matchedAdvertisement) {
    return null;
  }

  const { url, link } = matchedAdvertisement;
  
  if (isMobile) {
    return (
      <div className="advertisement">
        <div className="box">
          <div>
            <a href={link}>
              <CustomImage
                src={url}
                alt="Advertisement"
                width={500}
                height={500}
                object-fit="fill"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="advertisement">
      <div className="box">
        <div>
          <a href={link}>
            <CustomImage
              src={url}
              alt="Advertisement"
              width={334}
              height={326}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementSection; 